import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/index';
import HeroImage from '../../assets/homepage-hero.jpg';
import { toast } from 'react-toastify';
import { Typography, Modal, Paper, TextField, IconButton, InputAdornment } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Visibility, VisibilityOff } from '@material-ui/icons';



const styles = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundImage: `url('${HeroImage}')`,
    backgroundSize: 'cover',
    flexDirection: 'column'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },

  mainTitle: {
    marginBottom: '150px',

  },

  registerLink: {
    textDecoration: 'underline'
  }
});

// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       width: 250,
//     },
//   },
// };

const HomePage = ({ classes, theme }) => {
  const navigate = useNavigate();

  const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);

  const [state, setState] = useState({
    years: [],
    makes: [],
    models: [],
    trims: [],
    selectedYear: '',
    selectedMake: '',
    selectedModel: '',
    selectedTrim: '',
    makedisabled: true,
    modeldisabled: true,
    trimdisabled: true,
    buttondisabled: true,
    responseData: null,
    isNotSame: false
  });

  useEffect(() => {
    // Fetch years when the component mounts
    axios.get(process.env.REACT_APP_BASE_URL + 'product/years', { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        if (response.data) {
          setState((prevState) => ({
            ...prevState,
            years: response.data,
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, []);

  const handleYearChange = (event) => {
    const selectedYear = event.target.value;
    setState((prevState) => ({
      ...prevState,
      selectedYear,
      selectedMake: '',
      selectedModel: '',
      selectedTrim: '',
      makes: [],
      models: [],
      trims: [],
      makedisabled: false,
      modeldisabled: true,
      trimdisabled: true,
      buttondisabled: true,
    }));

    // Fetch makes based on the selected year
    axios.get(process.env.REACT_APP_BASE_URL + `product/make/${selectedYear}`, { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        if (response.data) {
          setState((prevState) => ({
            ...prevState,
            makes: response.data,
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleMakeChange = (event) => {
    const selectedMake = event.target.value;
    setState((prevState) => ({
      ...prevState,
      selectedMake,
      selectedModel: '',
      selectedTrim: '',
      models: [],
      trims: [],
      modeldisabled: false,
      trimdisabled: true,
      buttondisabled: true,
    }));

    // Fetch models based on the selected make
    axios.get(process.env.REACT_APP_BASE_URL + `product/model/${selectedMake}`, { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        if (response.data) {
          setState((prevState) => ({
            ...prevState,
            models: response.data,
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleModelChange = (event) => {
    const selectedModel = event.target.value;
    setState((prevState) => ({
      ...prevState,
      selectedModel,
      selectedTrim: '',
      trims: [],
      trimdisabled: false,
      buttondisabled: true,
    }));

    // Fetch trims based on the selected model
    axios.get(process.env.REACT_APP_BASE_URL + `product/trim/${selectedModel}`, { headers: { 'content-type': 'application/json' } })
      .then((response) => {
        if (response.data) {
          setState((prevState) => ({
            ...prevState,
            trims: response.data,
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  const handleTrimChange = (event) => {
    const selectedTrim = event.target.value;
    setState((prevState) => ({
      ...prevState,
      selectedTrim,
      buttondisabled: false,
    }));
  };

  const handleSubmit = () => {
    const { selectedYear, selectedMake, selectedModel, selectedTrim } = state;

    let selectedModelNew = selectedModel.split(' ').join('_');
    let selectedMakeNew = selectedMake.split(' ').join('_');
    let selectedTrimNew = selectedTrim.split(' ').join('_');
    console.log(selectedModelNew, 'selectedModelNew');
    navigate('/your-bicycle/' + selectedYear + '/' + selectedMakeNew + '/' + selectedModelNew + '/' + selectedTrimNew);
  };


  const srequestData = {
    name: state.suserName,
    email: state.semail,
    password: state.spassword,
  };

  const handleChange = (prop) => (event) => {
    setState({ ...state, [prop]: event.target.value });
  };

  const handleTogglePasswordVisibility = (field) => {
    setState({ ...state, [field]: !state[field] });
  };



  const headleSingUPUpModal = () => {

    if (state.spassword !== state.sconfirmPassword) {
      // Passwords don't match, handle error
      return setState((prevState) => ({
        ...prevState,
        isNotSame: true
      }));
    }
    axios.post(process.env.REACT_APP_BASE_URL + 'users/register', srequestData, {
      headers: { 'Content-Type': 'application/json' },
    }).then((response) => {
      // navigate('/your-bicycle', { state: { bicycle: response.data.bicycle } });
      console.log('aaaaaaaaaaaaaaaa', response.status);
      if (response.status === 201) {
        window.localStorage.setItem("token", response.data.token);
        window.localStorage.setItem("userID", response.data.user.id);
        closeSignUpModal();
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        // window.localStorage.setItem("token", response.data.token);

      } else {
        closeSignUpModal();
        toast.error(response.data.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
      .catch((error) => {
        closeSignUpModal();
        toast.error(error.response.data.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }


  const openSignUpModal = () => {
    setSignUpModalOpen(true);
  };


  const closeSignUpModal = () => {
    setSignUpModalOpen(false);
  };

  const handleChangeSingUserName = (event) => {
    setState((prevState) => ({
      ...prevState,
      suserName: event.target.value,
    }));
  }

  const handleChangeSingemailName = (event) => {
    setState((prevState) => ({
      ...prevState,
      semail: event.target.value,
    }));
  }

  const handleChangeSingPassword = (event) => {
    setState((prevState) => ({
      ...prevState,
      spassword: event.target.value,
    }));
  }






  return (
    <>
      <Header></Header>
      <div className={classes.root}>
        {!window.localStorage.getItem("token") && <h1 className={classes.mainTitle}>Ready to Begin? <a className={classes.registerLink} onClick={openSignUpModal}>Register</a> for Your Account</h1>}
        <Box className="homepage-form">
          <h2>Choose Your Bicycle</h2>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-year">Year</InputLabel>
            <Select
              value={state.selectedYear}
              onChange={handleYearChange}
              inputProps={{
                id: 'select-year',
              }}
            >

              {state.years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-make">Make</InputLabel>
            <Select
              value={state.selectedMake}
              onChange={handleMakeChange}
              inputProps={{
                id: 'select-make',
              }}
              disabled={state.makedisabled}
            >

              {state.makes.map((make) => (
                <MenuItem key={make} value={make}>
                  {make}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-model">Model</InputLabel>
            <Select
              value={state.selectedModel}
              onChange={handleModelChange}
              inputProps={{
                id: 'select-model',
              }}
              disabled={state.modeldisabled}
            >

              {state.models.map((model) => (
                <MenuItem key={model} value={model}>
                  {model}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-trim">Trim</InputLabel>
            <Select
              value={state.selectedTrim}
              onChange={handleTrimChange}
              inputProps={{
                id: 'select-trim',
              }}
              disabled={state.trimdisabled}
            >

              {state.trims.map((trim) => (
                <MenuItem key={trim} value={trim}>
                  {trim}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" disabled={state.buttondisabled} onClick={handleSubmit} className='home-submit-button'>
            Submit
          </Button>

        </Box>


        <Modal open={isSignUpModalOpen} onClose={closeSignUpModal}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <Paper style={{ padding: '20px', maxWidth: '500px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" gutterBottom>
                  Sign Up
                </Typography>
                <IconButton edge="end" color="inherit" onClick={closeSignUpModal}>
                  <CloseIcon />
                </IconButton>

              </div>

              <form>
                <TextField
                  label="Name"
                  margin="normal"
                  fullWidth
                  onChange={handleChangeSingUserName}
                // Add other props as needed
                />
                <TextField
                  label="Email"
                  type="email"
                  margin="normal"
                  fullWidth
                  onChange={handleChangeSingemailName}
                // Add other props as needed
                />
                <TextField
                  label="Password"
                  type={state.showPassword ? 'text' : 'password'}
                  value={state.spassword}
                  onChange={handleChange('spassword')}
                  margin="normal"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => handleTogglePasswordVisibility('showPassword')}>
                          {state.showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <TextField
                  label="Confirm Password"
                  type={state.showConfirmPassword ? 'text' : 'password'}
                  value={state.sconfirmPassword}
                  onChange={handleChange('sconfirmPassword')}
                  margin="normal"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={() => handleTogglePasswordVisibility('showConfirmPassword')}>
                          {state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={headleSingUPUpModal}
                  className="login-submit-button"
                // Add onClick or onSubmit handler
                >
                  Sign Up
                </Button>
                {console.log(state.isNotSame, "isnotsame")}
                {state.isNotSame && (
                  <div style={{ color: 'red' }}>Passwords don't match</div>
                )}
              </form>

            </Paper>
          </div>
        </Modal>
      </div>
    </>
  );
};

HomePage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(HomePage);
